<template>
  <div class="baseContent-warp">
    <Card>
      <span slot="title">患者签到记录</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getScanRecord)" class="fr">刷新</el-button>
      <div slot="content">
        <!-- 查询表单-->
        <el-form class="serach" :model="searchForm" inline>
          <el-form-item label="患者名称">
            <el-input v-model="searchForm.patientName" placeholder="请输入患者名称" />
          </el-form-item>
          <el-form-item label="医生姓名">
            <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
              default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签到日期">
            <el-date-picker v-model="searchForm.createTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择就诊日期"
              @change="$refresh(getScanRecord, true)" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getScanRecord, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getScanRecord, { patientName: null, createTime: null, doctorName: null })">重置</el-button>
          </el-form-item>
        </el-form>
        <div>
          <!-- 签到记录 -->
          <el-table v-loading="loading" style="font-size: 14px;" :max-height="tableHeight" :data="scanRecordList">
            <el-table-column type="index" label="序号" width="50" />
            <el-table-column label="患者信息">
              <el-table-column label="姓名" min-width="100">
                <template slot-scope="scope">{{ scope.row.hospPatientInfo.patientName }}</template>
              </el-table-column>
              <el-table-column label="性别">
                <template slot-scope="scope">
                  <div>{{ scope.row.hospPatientInfo.sex == 0 ? '男' : '女' }}</div>
                </template>
              </el-table-column>
              <el-table-column label="电话" min-width="120">
                <template slot-scope="scope">{{ scope.row.hospPatientInfo.phone }}</template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="排班信息">
              <el-table-column label="医生">
                <template slot-scope="scope">{{ scope.row.orderRegistered.doctorName }}</template>
              </el-table-column>
              <el-table-column label="诊室">
                <template slot-scope="scope">{{ scope.row.orderRegistered.schedulingItem.clinicName }}</template>
              </el-table-column>
              <el-table-column label="班次" min-width="160">
                <template slot-scope="scope">
                  {{ scope.row.orderRegistered.schedulingTimeInfo.timeName }}
                  ({{ scope.row.orderRegistered.schedulingTimeInfo.startTime | $computeTime }} -
                  {{ scope.row.orderRegistered.schedulingTimeInfo.stopTime | $computeTime }})
                </template>
              </el-table-column>
              <el-table-column label="序号">
                <template slot-scope="scope">{{ scope.row.orderRegistered.registeredCode }}</template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="createTime" label="签到时间" min-width="160" />
          </el-table>
          <!-- 分页 -->
          <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getScanRecord)" :total="total"
            :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
        </div>
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { scanRecord } from "@/api/registration"; // 挂号请求
export default {
  name: "Sign",
  data() {
    return {
      loading: true, // 加载
      scanRecordList: [], // 扫码签到记录
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数total
      doctorOptions: [], // 医生选项
      searchForm: { patientName: null, createTime: null, doctorName: null }, // 查询表单
      tableHeight: 0, // 表格最大高度
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280;
    this.getScanRecord(); // 获取签到记录
    this.$getDoctorOptions({ type: 0, status: 0 }); // 获取医生选项
  },
  methods: {
    // 获取扫码签到记录
    async getScanRecord() {
      let { code, rows, total } = await scanRecord({ pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
      if (code == 200) {
        this.total = total;
        this.scanRecordList = rows;
      }
      this.loading = false;
    },
  }
}
</script>